<script>
  import { createEventDispatcher } from "svelte";

  export let bold = false;
  export let color = "var(--primary-color)";
  export let shadow = false;
  export let size = "inherit";
  export let underline = true;

  const dispatch = createEventDispatcher();

  /**
   * Dispatch click event
   */
  function click() {
    dispatch("click");
  }
</script>

<style>
  button {
    --color: var(--color, var(--primary-color));
    --font-size: var(--font-size, inherit);
    background: transparent;
    border: 0;
    box-sizing: border-box;
    color: var(--color);
    cursor: pointer;
    font-size: var(--font-size);
    margin: 0;
    padding: 0;
  }

  button:focus {
    outline: 0;
  }

  .bold {
    font-weight: bold;
  }

  .shadow {
    -webkit-text-stroke: 4px var(--thin-shadow);
  }

  .underline:hover {
    text-decoration: underline;
  }
</style>

<button class:bold class:shadow class:underline type="button" on:click|preventDefault|stopPropagation={click} style="--color: {color}; --font-size: {size}">
  <slot />
</button>
